import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { dotmapsBlue } from '@constants/colors';
import { topBarStyles } from '@constants/mui-theme';
import LoaderIcon from '@shared/loader-icon';

// Wrapper to display an IconButton (the children prop), taking
// care of the downloading state (in that case, we display a loader
// icon instead).
const LoaderIconWrapper = ({ children, loaderColor = dotmapsBlue }) => {
  const downloading = useSelector(state => state.map.downloading);

  if (downloading > 0) {
    return (
      <div style={topBarStyles.loaderIconWrapper}>
        <LoaderIcon color={loaderColor} />
      </div>
    );
  }
  return children;
};

LoaderIconWrapper.propTypes = {
  children: PropTypes.node,
  loaderColor: PropTypes.string
};

export default LoaderIconWrapper;
